import type { Input } from '@builder.io/sdk';

const faqs = [
  {
    name: 'faqs',
    type: 'list',
    subFields: [
      {
        name: 'title',
        type: 'string',
      },
      {
        name: 'link',
        type: 'url',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const faqFields = [
  {
    name: 'heading',
    type: 'string',
  },
  {
    name: 'leftFaq',
    type: 'object',
    subFields: [
      {
        name: 'heading',
        type: 'string',
      },
      ...faqs,
    ],
  },
  {
    name: 'rightFaq',
    type: 'object',
    subFields: [
      {
        name: 'heading',
        type: 'string',
      },
      ...faqs,
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const faqConfig = {
  name: 'Faq',
  inputs: faqFields,
};

export type FAQProps = GenerateBuilder<typeof faqFields>;

export default faqConfig;
